import React from "react";
import "./App.css";
import Screen from "components/Screen/Screen";

function App() {
  return (
    <div className="App">
      <Screen></Screen>
    </div>
  );
}

export default App;
